class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();    
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.handleNestedScroll();

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');

    setTimeout(() => {
      if(!facetForm.dataset.terms) return;
      const terms = document.createElement('input')
      terms.type = "hidden"
      terms.name = "q"
      terms.value = facetForm.dataset.terms
      facetForm.appendChild(terms)      
    }, 3000)
    

    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    this.querySelectorAll('details').forEach((el) => {
      new Accordion(el);
    });

    this.querySelectorAll('details summary').forEach((el) => {
      el.addEventListener('click', this.onToggleFilter.bind(this));
    }); 

    this.filterProductsByInventoryOnLoad();
  }

  filterProductsByInventoryOnLoad() {
    const urlParams = new URLSearchParams(window.location.search);
    const size = urlParams.get('filter.v.option.size');  
    
    if (!size) return;
  
    document.querySelectorAll('.grid__item').forEach(product => {
      const sizeVariant = product.querySelector(`.size.product-form__input .variant-option[value="${size}"]`);
      if (sizeVariant.classList.contains('sold-out')) {
        product.closest('.grid__item').setAttribute('hidden', '');
      } else {
        product.closest('.grid__item').removeAttribute('hidden');
      }    
    });         
  }
  
  handleNestedScroll() {
    const filterItems = this.querySelectorAll('.filter__item');
    const facetFiltersForm = this.querySelector('form');

    filterItems.forEach((item) => {
      item.addEventListener('scroll', function() {
        if (item.scrollTop + item.clientHeight >= item.scrollHeight) {
          // Unlock FacetFiltersForm scroll
          facetFiltersForm.style.overflow = 'auto';
        } else {
          // Lock FacetFiltersForm scroll
          facetFiltersForm.style.overflow = 'hidden';
        }
      });
    });
  }


  onToggleFilter(event) {
    const clickedElement = event.target.closest('details');
    this.querySelectorAll('details').forEach((el) => {
      if (el !== clickedElement) {
        el.removeAttribute('open');
        el.classList.remove('details--active');
      }
    });
    clickedElement.setAttribute('open', '');
    clickedElement.classList.add('details--active');
  }
  
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener('popstate', onHistoryChange);

    const initialURLParams = new URLSearchParams(window.location.search);
    if (initialURLParams.has('sort_by')) {
      const sortValue = initialURLParams.get('sort_by');
      const sortLabel = document.querySelector(`input[name="sort_by"][value="${sortValue}"]`).nextElementSibling.textContent.trim();
      const activeFacetsInners = document.querySelectorAll('.active-facets__inner');
      const radioButton = document.querySelector(`input[name="sort_by"][value="${sortValue}"]`);
      
      if (radioButton) {
        radioButton.checked = true;
      }
      
      if (activeFacetsInners.length) {
        activeFacetsInners.forEach((activeFacetsInner) => {
          const newFacetHTML = `<facet-remove class="sort-remove"><a href="#" class="active-facets__button active-facets__button--light"><span class="active-facets__button-inner button button--tertiary"><span class="active-facet-value-text">Sort By: ${sortLabel}</span> <svg class="icon icon--close" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 18L18 6M6 6L18 18" stroke="#171717" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></a></facet-remove>`;
          const newFacetElement = new DOMParser().parseFromString(newFacetHTML, 'text/html').body.firstChild;
          
          const clearAllButton = activeFacetsInner.querySelector('.active-facets__button-wrapper');
          if (clearAllButton) {
            clearAllButton.parentNode.insertBefore(newFacetElement, clearAllButton);
          } else {
            activeFacetsInner.appendChild(newFacetElement);
          }
        });
      }
    }
    
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    FacetFiltersForm.removeExistingSortFacets();

    // Handle sort_by as an active facet
    const urlParams = new URLSearchParams(searchParams);
    if (urlParams.has('sort_by')) {
      const sortValue = urlParams.get('sort_by');
      const sortLabel = document.querySelector(`input[name="sort_by"][value="${sortValue}"]`).nextElementSibling.textContent.trim();
      const activeFacetsInners = document.querySelectorAll('.active-facets__inner');
      
      if (activeFacetsInners.length) {
        activeFacetsInners.forEach((activeFacetsInner) => {
          const newFacetHTML = `<facet-remove class="sort-remove"><a href="#" class="active-facets__button active-facets__button--light"><span class="active-facets__button-inner button button--tertiary"><span class="active-facet-value-text">Sort By: ${sortLabel}</span> <svg class="icon icon--close" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 18L18 6M6 6L18 18" stroke="#171717" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></a></facet-remove>`;
          const newFacetElement = new DOMParser().parseFromString(newFacetHTML, 'text/html').body.firstChild;
          
          const clearAllButton = activeFacetsInner.querySelector('.active-facets__button-wrapper');
          if (clearAllButton) {
            clearAllButton.parentNode.insertBefore(newFacetElement, clearAllButton);
          } else {
            activeFacetsInner.appendChild(newFacetElement);
          }
        });
      }
    }

    // document.querySelectorAll('details').forEach((el) => {
    //   el.removeAttribute('open');
    //   el.classList.remove('details--active');
    // });
    
  
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  
  static filterProductsByInventory(html, searchParams) {
    const urlParams = new URLSearchParams(searchParams);
    const size = urlParams.get('filter.v.option.size');
  
    if (!size) return html;
  
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const productElements = parsedHTML.querySelectorAll('.product-card');
  
    productElements.forEach(product => {
      const sizeVariant = product.querySelector(`.size.product-form__input .variant-option[value="${size}"]`);
      if (!sizeVariant || sizeVariant.classList.contains('sold-out')) {
        product.closest('.grid__item').setAttribute('hidden', '');
      } else {
        product.closest('.grid__item').removeAttribute('hidden');
      }
    });
  
    return parsedHTML.documentElement.outerHTML;
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const filteredHtml = FacetFiltersForm.filterProductsByInventory(responseText, url.split('?')[1]);
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html: filteredHtml, url }];
        FacetFiltersForm.renderFilters(filteredHtml, event);
        FacetFiltersForm.renderProductGridContainer(filteredHtml);
        FacetFiltersForm.renderProductCount(filteredHtml);
      });
  }


  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    const filteredHtml = FacetFiltersForm.filterProductsByInventory(html, window.location.search);
    FacetFiltersForm.renderFilters(filteredHtml, event);
    FacetFiltersForm.renderProductGridContainer(filteredHtml);
    FacetFiltersForm.renderProductCount(filteredHtml);
  }


  static renderProductGridContainer(html) {
    const containers = document.querySelectorAll('#ProductGridContainer');
    const newContent = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    containers.forEach((container) => {
      container.innerHTML = newContent;
    });
  }
  
  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const containers = document.querySelectorAll('#ProductCount');
    containers.forEach((container) => {
      container.innerHTML = count;
      container.classList.remove('loading');
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
  
    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
  
    const selectedSortByRadio = document.querySelector('input[name="sort_by"]:checked');
    if (selectedSortByRadio) {
      const selectedLabel = selectedSortByRadio.nextElementSibling.textContent.trim();
      const newFacetHTML = `<facet-remove class="sort-remove"><a href="#" class="active-facets__button active-facets__button--light"><span class="active-facets__button-inner button button--tertiary"><span class="active-facet-value-text">Sort By: ${selectedLabel}</span> <svg class="icon icon--close" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 18L18 6M6 6L18 18" stroke="#171717" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></a></facet-remove>`;
      
      const parsedActiveFacetsInner = parsedHTML.querySelector('.active-facets__inner');
      if (parsedActiveFacetsInner) {
        const clearAllButton = parsedActiveFacetsInner.querySelector('.active-facets__button-wrapper');
        if (clearAllButton) {
          parsedActiveFacetsInner.innerHTML = parsedActiveFacetsInner.innerHTML.replace(clearAllButton.outerHTML, newFacetHTML + clearAllButton.outerHTML);
        } else {
          parsedActiveFacetsInner.innerHTML += newFacetHTML;
        }
      }
    }
  
    const activeFacetContainers = document.querySelectorAll('.active-facets');
    activeFacetContainers.forEach((container) => {
      container.innerHTML = parsedHTML.querySelector('.active-facets').innerHTML;
    });
  
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
  
    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }
  
  

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.removeExistingSortFacets();

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('sort_by')) {
      const sortValue = urlParams.get('sort_by');
      const sortLabel = document.querySelector(`input[name="sort_by"][value="${sortValue}"]`).nextElementSibling.textContent.trim();
      const activeFacetsInners = document.querySelectorAll('.active-facets__inner');
      
      if (activeFacetsInners.length) {
        activeFacetsInners.forEach((activeFacetsInner) => {
          const newFacetHTML = `<facet-remove class="sort-remove"><a href="#" class="active-facets__button active-facets__button--light"><span class="active-facets__button-inner button button--tertiary"><span class="active-facet-value-text">Sort By: ${sortLabel}</span> <svg class="icon icon--close" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 18L18 6M6 6L18 18" stroke="#171717" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></a></facet-remove>`;
          const newFacetElement = new DOMParser().parseFromString(newFacetHTML, 'text/html').body.firstChild;
          
          const clearAllButton = activeFacetsInner.querySelector('.active-facets__button-wrapper');
          if (clearAllButton) {
            clearAllButton.parentNode.insertBefore(newFacetElement, clearAllButton);
          } else {
            activeFacetsInner.appendChild(newFacetElement);
          }
        });
      }
    }    

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    setTimeout(() => {
      const promoBanners = document.querySelectorAll('.promo-banner');
      if (promoBanners[0] != null) {
        promoBanners.forEach((el) => {
          el.classList.add('scroll-animation--active');
        });
      }
    }, 1000);

    document.querySelectorAll('facet-filters-form details').forEach((el) => {
      new Accordion(el);
    });

    setTimeout(() => {
      document.querySelectorAll('#product-grid .splide').forEach(el => {
        const splide = new Splide(el);

        splide.on('mounted', function () {        
          const roles = document.querySelectorAll('.splide [role]');
                  
          roles.forEach(function (element) {
            element.removeAttribute('role');
          });
        });
        
        splide.mount();
      });
    }, 500)    
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    let currentSortBy = new URLSearchParams(window.location.search).get('sort_by'); // Get current sort_by value

    if (event.srcElement.className == 'facets__checkbox') {
      let searchParams = this.createSearchParams(event.target.closest('form'));
      if (currentSortBy) { // If sort_by exists, append it
        searchParams += `&sort_by=${currentSortBy}`;
      }
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];

      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }    
  }

  static removeExistingSortFacets() {
    document.querySelectorAll('.sort-remove').forEach((element) => {
      element.remove();
    });
  }  
  
  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    let url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
  
    // Remove sort_by if it's the clicked facet
    if (event.currentTarget.closest('.sort-remove')) {
      const urlParams = new URLSearchParams(url);
      urlParams.delete('sort_by');
      url = urlParams.toString();
    }
  
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.field__input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
    this.querySelectorAll('.price-range__slider input').forEach((element) =>
      element.addEventListener('change', this.setSliderValues.bind(this))
    );
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('.field__input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    const ranges = this.querySelectorAll('.price-range__slider input');

    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));

    ranges[0].value = minInput.value;
    ranges[1].value = maxInput.value;
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  setSliderValues() {
    const ranges = this.querySelectorAll('.price-range__slider input');
    let range1 = Number(ranges[0].value);
    let range2 = Number(ranges[1].value);
    const inputs = this.querySelectorAll('.field__input');

    if (range1 > range2) {
      let tmp = range2;
      range2 = range1;
      range1 = tmp;
    }

    inputs[0].value = range1;
    inputs[1].value = range2;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    const modalBtn = this.querySelector('.filter-modal__close');

    if (modalBtn) {
      modalBtn.addEventListener('click', (el) => {
        el.target.closest('details').querySelector('summary').click();
      });
    }

    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', () => {
      this.closeFilter.bind(this)
      if(facetLink.textContent.contains('Clear All')){
        document.querySelectorAll('.grid__item').forEach(item => {
          item.removeAttribute('hidden')
        })
      }
    });    
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);